import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/24/outline';

export const SIDEBAR_SECTION_ITEM_CLASSES =
  'block h-8 text-sm leading-8 pr-2 pl-2 rounded-lg text-left transition-colors cursor-pointer text-gray-600 group-hover:bg-gray-200 group-hover:text-gray-900 truncate';

const SidebarSection = ({ title, children, open, setOpen, tutorial }) => {
  return (
    <div className='mt-3'>
      <div className='mx-2'>
        <button
          data-tutorial-id={tutorial}
          onClick={() => setOpen((prev) => !prev)}
          className='group flex items-center justify-between w-full h-8 pl-2 pr-[10px] rounded-lg hover:bg-gray-200 transition-colors'>
          <h2 className='text-xs text-gray-600 group-hover:text-gray-900 transition-colors'>
            {title}
          </h2>
          {open ? (
            <ChevronUpIcon className='h-3.5 w-3.5 text-gray-500 opacity-0 group-hover:opacity-100 transition-opacity' />
          ) : (
            <ChevronDownIcon className='h-3.5 w-3.5 text-gray-500 opacity-0 group-hover:opacity-100 transition-opacity' />
          )}
        </button>
      </div>
      <div
        className='grid transition-all duration-200 ease-in-out'
        style={{
          gridTemplateRows: open ? '1fr' : '0fr',
          opacity: open ? 1 : 0,
        }}>
        <div className='overflow-hidden'>{children}</div>
      </div>
    </div>
  );
};

export default SidebarSection;
